module.exports = __webpack_public_path__ + "img/HZ-T1329.0084532c.jpg";